import store from '@/store'
import data_status from '@/data/data_status'
import { generate_card } from '@/js/board'
import { random } from '@/js/utils'

export const fire_trigger = (slug, data = {}) => {

	// TRIGGERS FROM CHARACTER
	const triggerables = [ data.from_character, ...data.from_character.equipments, ...data.from_character.talismans ]
	triggerables.forEach((triggerable) => {
		triggerable.triggers.forEach((trigger) => {
			if (trigger.on === slug) {
				if (
					(!trigger.if) || 
					(trigger.if === 'no-equipments' && data.from_character.equipments.length === 0)
				) {
					if (!trigger.probability || (random(100) < trigger.probability)) {
						console.log('TRIGGER:', slug.toUpperCase(), trigger.method + '()')
						actions[trigger.method](triggerable, trigger, data)
					}
				}
			}
		})
	})

}

const actions = {

	give: (triggerable, trigger, data) => {
		
		Object.entries(trigger).forEach((entry) => {
			const [ key, value ] = entry
			if (data_status.find(s => s.slug === key)) {
				store.dispatch('add_card_status', { status: key, card: data.from_character, value, turn: store.getters.game.current_turn + 1 })
			}
		})

		let values = {}

		if (trigger.life) values.life = data.from_character.life + trigger.life
		if (trigger.gold) values.gold = data.from_character.gold + trigger.gold

		if (values) {
			store.commit('EDIT_GAME_OBJ', { obj: data.from_character, ...values })
		}
	},

	gain_attack: (triggerable, trigger) => {
		if (triggerable.attack !== undefined) {
			store.commit('EDIT_GAME_OBJ', { obj: triggerable, attack: triggerable.attack + trigger.value })
		}
	},

	gain_gold: (triggerable, trigger, data) => {
		if (data.from_character.gold !== undefined) {
			store.commit('EDIT_GAME_OBJ', { obj: data.from_character, gold: data.from_character.gold + trigger.value })
		}
	},

	deal_damage_to_adjacent_enemy: (triggerable, trigger, data) => {
		const next_enemy = store.getters.game.board.find(c => c.position === data.from_character.position + 2 && c.type === 'enemy')
		if (next_enemy) {
			store.dispatch('deal_damage', { victim: next_enemy, damage: trigger.value })
		}
	},

	heal: (triggerable, trigger, data) => {
		if (data.from_character !== undefined) {
			store.commit('EDIT_GAME_OBJ', { obj: data.from_character, life: data.from_character.life + trigger.value })
		}
	},

	give_attack_to_other_enemies: (triggerable, trigger, data) => {
		store.getters.game.board.filter(c => c.type === 'enemy' && c.room === store.getters.room).forEach((enemy) => {
			store.commit('EDIT_GAME_OBJ', { obj: enemy, attack: enemy.attack + trigger.value })
		})
	},

	give_card: (triggerable, trigger) => {
		let values = {}
		if (trigger.card) values.slug = trigger.card
		else if (trigger.card_type) values.type = trigger.card_type
		store.dispatch('draw_card', { card: generate_card(values) })
	},

	deal_poison_to_opponent: (triggerable, trigger, data) => {
		store.dispatch('add_card_status', { card: data.opponent, status: 'poison', value: trigger.value })
	},

	push_opponent: (triggerable, trigger, data) => {
		store.dispatch('push_card', { card: data.opponent })
	},

	add_equipment: (triggerable, trigger, data) => {
		store.dispatch('add_equipment', { character: data.from_character, equipment: generate_card({ slug: trigger.equipment }) })
	},

}